import React from 'react'
import { Card, AuthorImage } from '../../../atoms'

interface IAboutAuthorDetails {
  imgUrl: string
  authorPageUrl: string
  name: string
  desc: string
}

export interface IAboutAuthorCardProps {
  name: string
  jsonBody: IAboutAuthorDetails
  showHeader: boolean
}

const AboutAuthorCard = ({ jsonBody, name, showHeader }: IAboutAuthorCardProps) => {
  try {
    return (
      <div className='author-module' id={name}>
        <Card variant='modal'>
          {showHeader && <h4 className='author-module__heading'>About the author</h4>}
          <div className='author-module__container'>
            <div className='author-module__container__img-box'>
              <AuthorImage src={jsonBody.imgUrl} variant='large' />
              <span className='author-module__name-mobile'>
                <a href={jsonBody.authorPageUrl}>{jsonBody.name}</a>
              </span>
            </div>
            <div>
              <span className='author-module__name-desktop'>
                <a href={jsonBody.authorPageUrl}>{jsonBody.name}</a>
              </span>
              <div className='author-module__desc'>{jsonBody.desc}</div>
            </div>
          </div>
        </Card>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default AboutAuthorCard
